<template>
  <div>
    <v-dialog v-model="photoDialog">
      <v-card>
        <v-img
          :src="photoDialogUrl || null"
        ></v-img>
      </v-card>
    </v-dialog>
    <v-container fluid>
      <v-expansion-panels
        accordion
        multiple
        v-if="Object.keys(cart.items).length"
      >
        <v-expansion-panel
          v-for="(date, dateStr, index) in cart.items"
          :key="index"
        >
          <v-expansion-panel-header>
            <tr>
              <th class="cart-heading">{{getLocalizedWeekDay(dateStr)}}</th>
              <th class="cart-heading">{{getLocalizedDate(dateStr)}}</th>
              <td class="cart-heading">{{getSelectedTimesStr(dateStr)}}</td>
              <td class="cart-heading">{{getDayPrice(dateStr)}} Kč</td>
            </tr>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-for="(time, i) in date"
              :key="i">
              <v-data-table
                v-if="time.length"
                :headers="headers"
                :items="time"
                :expanded="expanded"
                item-key="id"
                show-expand
                class="elevation-1 order-table"
                hide-default-footer
                disable-sort
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title>{{timeTypes.length ? timeTypes[i].name : ''}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon
                      class="justify-end"
                      color="red"
                      @click="recapDeleteTime(dateStr, i)"
                      v-if="time[0].editable"
                    >mdi-delete-forever</v-icon>
                  </v-toolbar>
                </template>
                <template v-slot:item.photo="{ item }">
                  <v-icon
                    v-if="item.imageUrl"
                    small
                    class="mr-2"
                    @click="showPhoto(item.imageUrl)"
                  >
                    mdi-camera
                  </v-icon>
                </template>
                <template v-slot:item.quantity="{ item }" v-if="cart.order">
                  <v-text-field
                    v-model="item.quantity"
                    class="order-quantity"
                    type="number" min="1"
                    v-if="item.editable"
                    style="min-width: 100px !important;" dense>
                    <v-icon slot="append" color="green" @click="plusQuantityRecap(item)">mdi-plus</v-icon>
                    <v-icon slot="prepend" color="red" @click="minusQuantityRecap(item)">mdi-minus</v-icon>
                  </v-text-field>
                </template>
                <template v-slot:item.quantity="{ /* item */ }" v-else>
                  Objednáno
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td
                    :colspan="headers.length"
                    v-if="item.type === 'App\\Menu'"
                  >
                    <div
                      v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                    >{{menuItem.name}}</div>
                  </td>
                  <td
                    :colspan="headers.length"
                    v-else
                  >{{item.name}}</td>
                </template>
              </v-data-table>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-else>
        Košík je prázdný
      </div>
    </v-container>
    <div class="order-control-buttons text-right">
      <v-dialog v-model="userPreviewDialog">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="float-left" >
            Přehled uživatelů
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Přehled uživatelů</v-card-title>
          <v-card-text>
            <v-col>
              Objednávka pro uživatele: {{cart.order ? 'Ano' : 'Ne'}}
            </v-col>
            <v-col>
              <h3>Strávníci</h3>
              <div v-for="(boarder, index) in cart.boarders" :key="index">
                {{boarder.fullName}}
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn text @click="cancelOrder">Zrušit</v-btn>
      <v-btn color="warning" @click="continueShopping()" class="mr-2">Přidat do košíku</v-btn>
      <v-btn color="success" @click="goToBillingInformation">Další krok</v-btn>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'Step3',
  data () {
    return {
      userPreviewDialog: false,
      expanded: [],
      headers: [
        { text: '', value: 'photo', sortable: false },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena', value: 'price' },
        { text: '', value: 'data-table-expand' },
        { text: '', value: 'quantity' }
      ],
      photoDialogUrl: null,
      photoDialog: false
    }
  },
  methods: {
    cancelOrder () {
      this.reset()
      this.$emit('order-canceled')
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    getSelectedTimesStr (date) {
      let timeNames = []
      if (this.timeTypes.length) {
        timeNames = [0, 1, 2, 3, 4, 5]
          .map(time => this.timeTypes[time].name)
      }
      return timeNames
        .filter((time, index) => this.cart.items[date][index].length)
        .join(', ')
    },
    getDayPrice (date) {
      const itemsPrices = this.cart.items[date]
        .flat()
        .map(item => item.quantity * item.price)
      return itemsPrices.reduce((prev, next) => prev + +next, 0)
    },
    showPhoto (url) {
      this.photoDialog = true
      const base = axios.defaults.baseURL.split('/')
      this.photoDialogUrl = `${base.slice(0, 3).join('')}${url}`
    },
    recapDeleteTime (date, timeIndex) {
      this.deleteTimeIndex({ date, timeIndex })
      this.updateShoppingCartStorage()
      this.$forceUpdate()
    },
    continueShopping () {
      this.dateDialog = true
      this.addToCartDialog = false
      this.expanded = []
      this.goToStep(2)
    },
    plusQuantityRecap (item) {
      ++item.quantity
      this.updateShoppingCartStorage()
    },
    minusQuantityRecap (item) {
      if (item.quantity > 1) {
        --item.quantity
        this.updateShoppingCartStorage()
      }
    },
    goToBillingInformation () {
      Object.keys(this.cart.items).forEach(day => {
        this.cart.items[day] = this.cart.items[day].map(time => time.filter(food => food.quantity > 0))

        if (!this.cart.items[day].flat().length) {
          delete this.cart.items[day]
        }
      })
      this.goToStep(4)
      this.$forceUpdate()
    },
    ...mapMutations({
      reset: 'ordering/reset',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage',
      deleteTimeIndex: 'ordering/orderingStep3DeleteTime',
      goToStep: 'ordering/goToOrderingStep'
    })
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      timeTypes: 'ordering/timeTypes',
      step: 'ordering/step'
    }),
    // vuex bindings
    'cart.items': {
      get () {
        return this.$store.shoppingCart.state.cart.items
      },
      set (items) {
        this.$store.shoppingCart.state.cart.items = items
      }
    }
  }
}
</script>

<style scoped>

</style>
